module.exports = __webpack_public_path__ + "static/no-image-placeholder-1680f233f535c042bd4af2c099683e3a.jpg";